import { Dispatch, SetStateAction } from "react";

import {
  changeDateFormat,
  removeDoubleDate,
} from "@/app/(main)/(club)/mes-clubs/[id]/utils/utils";
import { getBackAPIUrl } from "@/app/api/dynabuy-back/getBackAPIUrl";
import { HydraEnum } from "@/TS/Enums/global_enums";
import { EventRead } from "@/TS/Interfaces/global_interfaces";
import { fetchWithNoStore } from "@/utils/api-utils";
import { CustomError } from "@/utils/init-globals";

export const getClubEventsFromClient = async (
  setIsLoading: Dispatch<SetStateAction<boolean>>,
  token: string | undefined,
  signal: AbortSignal,
  slug: string,
  page: number = 1,
  startDate: Date,
): Promise<EventRead[]> => {
  setIsLoading(true);
  const backAPIUrl = await getBackAPIUrl();
  let end = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1);

  const formattedStartDate = changeDateFormat(startDate);
  const formattedEndDate = changeDateFormat(end);
  let headers: Record<string, string> = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = "Bearer " + token;

  const response = await fetchWithNoStore(
    `${backAPIUrl}/events?` +
      new URLSearchParams({
        clubSlug: slug,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        page: page.toString(),
      }),
    {
      signal,
      method: "GET",
      headers: headers,
    },
  );

  if (!response.ok) {
    throw new CustomError("Network response was not ok");
  }
  setIsLoading(false);
  const members = await response.json();

  return removeDoubleDate(members[HydraEnum.LIST]);
};

export const getClubEventFromClient = async (
  clubSlug: string,
  startDate: Date,
  token?: string,
) => {
  const backAPIUrl = await getBackAPIUrl();

  let headers: Record<string, string> = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = "Bearer " + token;

  const response = await fetchWithNoStore(
    `${backAPIUrl}/events/meeting/${clubSlug}/${startDate.toISOString().split("T")[0]}`,
    {
      method: "GET",
      headers: headers,
    },
  );

  if (!response.ok) {
    throw new CustomError("Network response was not ok");
  }

  return await response.json();
};
